export const timeouts = {
  ads_refresh: 500,
};
